import * as Types from '../../../graphql.d';

import { StrapiImageFragment } from '../../strapi-image.fragment.generated';
import { gql } from '@apollo/client';
import { StrapiImageFragmentDoc } from '../../strapi-image.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type ProductSectionQueryVariables = Types.Exact<{
  productSlug: Types.Scalars['String'];
}>;


export type ProductSectionQuery = { __typename?: 'query_root', productEntries?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalogEntityResponse', data?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalogEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalog', catalogId: string, entries?: Types.Maybe<Array<Types.Maybe<{ __typename?: 'ComponentEntriesSmartphoneEntry', id: string, category?: Types.Maybe<Types.Enum_Componententriessmartphoneentry_Category>, releaseDate?: Types.Maybe<string>, isPreOrder?: Types.Maybe<boolean>, deliveryDate?: Types.Maybe<any>, formerUpfrontPriceInCentsInclundingTax?: Types.Maybe<number>, blackFridayFormerUpfrontPriceInCentsInclundingTax?: Types.Maybe<number>, subscriptionDrop?: Types.Maybe<Array<Types.Maybe<{ __typename?: 'ComponentEntriesSubscriptionDrop', formerSubscriptionPriceInCentsIncludingTax?: Types.Maybe<number>, formerUpfrontPriceInCentsIncludingTax?: Types.Maybe<number>, subscriptions?: Types.Maybe<{ __typename?: 'SmartphoneSubscriptionRelationResponseCollection', data: Array<{ __typename?: 'SmartphoneSubscriptionEntity', attributes?: Types.Maybe<{ __typename?: 'SmartphoneSubscription', sku: string }> }> }> }>>>, tags?: Types.Maybe<{ __typename?: 'TagRelationResponseCollection', data: Array<{ __typename?: 'TagEntity', attributes?: Types.Maybe<{ __typename?: 'Tag', slug: string }> }> }>, subscriptions?: Types.Maybe<{ __typename?: 'SmartphoneSubscriptionRelationResponseCollection', data: Array<{ __typename?: 'SmartphoneSubscriptionEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneSubscription', sku: string, subscriptionItem?: Types.Maybe<{ __typename?: 'items', id: number, properties?: Types.Maybe<any>, priceExcludingTax?: Types.Maybe<number>, tax?: Types.Maybe<{ __typename?: 'taxes', id: number, amount: any }>, stock?: Types.Maybe<{ __typename?: 'devices_stock_view_cache', isOnline?: Types.Maybe<boolean> }> }>, smartphoneVariant?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneVariant', slug: string, storage?: Types.Maybe<string>, colorName?: Types.Maybe<string>, smartphoneSubscriptions?: Types.Maybe<{ __typename?: 'SmartphoneSubscriptionRelationResponseCollection', data: Array<{ __typename?: 'SmartphoneSubscriptionEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneSubscription', sku: string }> }> }>, frontPicture?: Types.Maybe<(
                        { __typename?: 'UploadFileEntityResponse' }
                        & StrapiImageFragment
                      )>, backPicture?: Types.Maybe<(
                        { __typename?: 'UploadFileEntityResponse' }
                        & StrapiImageFragment
                      )>, combinedPicture?: Types.Maybe<(
                        { __typename?: 'UploadFileEntityResponse' }
                        & StrapiImageFragment
                      )> }> }> }> }> }> }> }>>> }> }> }>, smartphoneFamilies?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntityResponseCollection', data: Array<{ __typename?: 'SmartphoneFamilyEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneFamily', model: string, brand?: Types.Maybe<string>, dasValues?: Types.Maybe<string>, description?: Types.Maybe<any>, tips?: Types.Maybe<Array<Types.Maybe<{ __typename?: 'ComponentTipsCategory', id: string, name: string, articles: Array<Types.Maybe<{ __typename?: 'ComponentTipsArticle', name: string, slug: string, content: string, seo: { __typename?: 'ComponentSharedSeo', metaTitle: string, metaDescription: string, canonicalURL?: Types.Maybe<string>, keywords?: Types.Maybe<string>, metaImage: { __typename?: 'UploadFileEntityResponse', data?: Types.Maybe<{ __typename?: 'UploadFileEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'UploadFile', formats?: Types.Maybe<any> }> }> } } }>> }>>>, ogImage?: Types.Maybe<{ __typename?: 'UploadFileEntityResponse', data?: Types.Maybe<{ __typename?: 'UploadFileEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'UploadFile', formats?: Types.Maybe<any> }> }> }>, replacement?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneFamily', model: string, slug: string, smartphoneVariants?: Types.Maybe<{ __typename?: 'SmartphoneVariantRelationResponseCollection', data: Array<{ __typename?: 'SmartphoneVariantEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneVariant', slug: string, colorName?: Types.Maybe<string>, storage?: Types.Maybe<string>, combinedPicture?: Types.Maybe<(
                      { __typename?: 'UploadFileEntityResponse' }
                      & StrapiImageFragment
                    )>, smartphoneSubscriptions?: Types.Maybe<{ __typename?: 'SmartphoneSubscriptionRelationResponseCollection', data: Array<{ __typename?: 'SmartphoneSubscriptionEntity', attributes?: Types.Maybe<{ __typename?: 'SmartphoneSubscription', subscriptionItem?: Types.Maybe<{ __typename?: 'items', properties?: Types.Maybe<any> }> }> }> }> }> }> }> }> }> }>, descriptionImage?: Types.Maybe<(
          { __typename?: 'UploadFileEntityResponse' }
          & StrapiImageFragment
        )> }> }> }>, upfronts: Array<{ __typename?: 'items', id: number, sku: string, properties?: Types.Maybe<any>, priceExcludingTax?: Types.Maybe<number>, tax?: Types.Maybe<{ __typename?: 'taxes', id: number, amount: any }> }>, websiteSetting?: Types.Maybe<{ __typename?: 'WebsiteSettingEntityResponse', data?: Types.Maybe<{ __typename?: 'WebsiteSettingEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'WebsiteSetting', isBlackFriday: boolean }> }> }> };


export const ProductSectionDocument = gql`
    query productSection($productSlug: String!) {
  productEntries: b2CSmartphoneCatalog {
    data {
      id
      attributes {
        catalogId
        entries(
          filters: {subscriptions: {smartphoneVariant: {smartphoneFamily: {slug: {eq: $productSlug}}}}}
        ) {
          id
          category
          releaseDate
          isPreOrder
          deliveryDate
          formerUpfrontPriceInCentsInclundingTax
          blackFridayFormerUpfrontPriceInCentsInclundingTax
          subscriptionDrop {
            formerSubscriptionPriceInCentsIncludingTax
            formerUpfrontPriceInCentsIncludingTax
            subscriptions {
              data {
                attributes {
                  sku
                }
              }
            }
          }
          tags {
            data {
              attributes {
                slug
              }
            }
          }
          subscriptions(
            filters: {smartphoneVariant: {smartphoneFamily: {slug: {eq: $productSlug}}}}
          ) {
            data {
              id
              attributes {
                sku
                subscriptionItem {
                  id
                  properties
                  priceExcludingTax: sell_price_in_cents_excl_tax
                  tax {
                    id
                    amount
                  }
                  stock {
                    isOnline: is_online
                  }
                }
                smartphoneVariant {
                  data {
                    id
                    attributes {
                      slug
                      storage
                      colorName
                      smartphoneSubscriptions {
                        data {
                          id
                          attributes {
                            sku
                          }
                        }
                      }
                      frontPicture {
                        ...StrapiImage
                      }
                      backPicture {
                        ...StrapiImage
                      }
                      combinedPicture {
                        ...StrapiImage
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  smartphoneFamilies(filters: {slug: {eq: $productSlug}}) {
    data {
      id
      attributes {
        model
        brand
        dasValues
        tips {
          id
          name
          articles {
            name
            slug
            content
            seo {
              metaTitle
              metaDescription
              canonicalURL
              keywords
              metaImage {
                data {
                  id
                  attributes {
                    formats
                  }
                }
              }
            }
          }
        }
        ogImage {
          data {
            id
            attributes {
              formats
            }
          }
        }
        replacement {
          data {
            id
            attributes {
              model
              slug
              smartphoneVariants(pagination: {limit: 1}) {
                data {
                  id
                  attributes {
                    slug
                    colorName
                    storage
                    combinedPicture {
                      ...StrapiImage
                    }
                    smartphoneSubscriptions {
                      data {
                        attributes {
                          subscriptionItem {
                            properties
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        description
        descriptionImage {
          ...StrapiImage
        }
      }
    }
  }
  upfronts: items(
    where: {item_type: {_eq: "Upfront"}, _not: {properties: {_contains: {private: true}}}, is_online: {_eq: true}}
  ) {
    id
    sku
    properties
    priceExcludingTax: sell_price_in_cents_excl_tax
    tax {
      id
      amount
    }
  }
  websiteSetting {
    data {
      id
      attributes {
        isBlackFriday
      }
    }
  }
}
    ${StrapiImageFragmentDoc}`;
export function useProductSectionQuery(baseOptions: Apollo.QueryHookOptions<ProductSectionQuery, ProductSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductSectionQuery, ProductSectionQueryVariables>(ProductSectionDocument, options);
      }
export function useProductSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductSectionQuery, ProductSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductSectionQuery, ProductSectionQueryVariables>(ProductSectionDocument, options);
        }
export type ProductSectionQueryHookResult = ReturnType<typeof useProductSectionQuery>;
export type ProductSectionLazyQueryHookResult = ReturnType<typeof useProductSectionLazyQuery>;
export type ProductSectionQueryResult = Apollo.QueryResult<ProductSectionQuery, ProductSectionQueryVariables>;